import { setupOTEL } from "./otel";
import { browserAgent } from "./newrelic";
import {
  setupDropoffTracking,
  updateDropoffContext,
  resetDropoffState,
} from "./dropoff-tracking";

export function setupTelemetry(): void {
  if (import.meta.env.VITE_TELEMETRY_ENABLED === "false") return;
  setupOTEL();
}

export function setupNewRelic(): () => void {
  browserAgent.start();
  browserAgent.setCustomAttribute(
    "app_version",
    (window as unknown as Record<string, string>).__CHECKOUT_WEBAPP_VERSION__ ?? "",
  );
  browserAgent.setCustomAttribute("app_name", "checkout_v2");

  const cleanupDropoffTracking = setupDropoffTracking();

  const newRelicEvents = new Set([
    "PAYMENT_PLAN_SELECTION_SCREEN_VIEWED",
    "PAYMENT_PLAN_SELECTION_SCREEN_EXITED",
    "PAYMENT_CONFIRMATION_SCREEN_VIEWED",
    "PAYMENT_CONFIRMATION_SCREEN_EXITED",
    "IVR_SCREEN_VIEWED",
    "IVR_SCREEN_EXITED",
  ]);

  const onAppEventReceived = (e: Event): void => {
    const eventDetail = (e as CustomEvent).detail as Record<string, unknown> | undefined;
    const eventName = (eventDetail?.name as string) ?? "unknown_event";
    const attributes = (eventDetail?.attributes as Record<string, string>) ?? {};

    if (newRelicEvents.has(eventName)) {
      browserAgent.log(eventName, { customAttributes: attributes });
    }

    if (
      eventName.includes("CLICKED") ||
      eventName.includes("SELECTED") ||
      eventName.includes("SUBMITTED")
    ) {
      resetDropoffState();
    }

    if (attributes.checkout_id && attributes.order_id) {
      updateDropoffContext(attributes.checkout_id, attributes.order_id);
    }

    if ((import.meta.env.VITE_APP_ENV ?? "") === "development") {
      console.log(eventName, attributes);
    }
  };

  window.addEventListener("app_event", onAppEventReceived);

  window.addEventListener("checkout_default_event_attributes", (e: Event) => {
    const attrs = ((e as CustomEvent).detail ?? {}) as Record<string, string>;

    if (attrs.checkout_id && attrs.order_id) {
      updateDropoffContext(attrs.checkout_id, attrs.order_id);
    }

    Object.keys(attrs).forEach((key) => {
      browserAgent.setCustomAttribute(key, attrs[key]);
    });
  });

  return () => {
    cleanupDropoffTracking();
    window.removeEventListener("app_event", onAppEventReceived);
  };
}

export { browserAgent } from "./newrelic";
export { updateDropoffContext, resetDropoffState, setupDropoffTracking } from "./dropoff-tracking";
